import { apiGet, apiPost } from "../../utils"

export function uploadAnalysisFileAPI(formData) {
    return apiPost('/api/uploadAnalysisFile', formData)
}

export function getAnalysisFilesAdminAPI(store) {
    const query = store ? `?store=${store}` : ''
    return apiGet(`/api/getAnalysisFilesAdmin${query}`)
}

export function deleteAnalysisFileAdminAPI(data) {
    return apiPost('/api/deleteAnalysisFileAdmin', data)
}
